module.exports = __webpack_public_path__ + "static/img/1080_small.815f4ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1080_small.png
// module id = eLHd
// module chunks = 1